const DecisionTree = () => {
    return(
        <p className="text-teal-500 font-semibold">Decision Tree</p>
    )
}

export default DecisionTree;